export interface GlobalErrorPayload {
    type: GlobalErrorType;
    status: number;
    title: string;
    message: string;
}

export enum GlobalErrorType {
    Alert = 'alert',
    Dialog = 'dialog'
}
